// Export the Component Definition for use in Contentful Studio
export {EditorialCardContentfulComponentDefinition} from './EditorialCardContentfulDefinition';
export {default} from './EditorialCard';
